import { blue } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(({ spacing }) => ({
  maintenanceRoot: {
    display: "flex",
    backgroundColor: blue[50],
    justifyContent: "center",
    alignItems: "center",
    padding: spacing(1.5, 0),
    gap: spacing(1),
    width: "100vw",
    marginLeft: "calc(-50vw + 50%)",
    marginRight: "calc(-50vw + 50%)",
  },
  maintenanceModeText: {
    color: "black",
    fontSize: "12px",
    lineHeight: "150%",
  },
  maintenanceModeIcon: {
    width: "18px",
    height: "18px",
  },
}));

export default useStyles;
